declare global {
  interface Window {
    _paq?: MatomoCommand[];
  }
}

type MatomoValue = string | number | boolean | null | undefined;
type MatomoCommand = [string, ...MatomoValue[]];

const pushMatomo = (command: MatomoCommand) => {
  if (typeof window === 'undefined') {
    return;
  }

  window._paq = window._paq || [];
  window._paq.push(command);
};

export const trackMatomoEvent = (
  category: string,
  action: string,
  name?: string,
  value?: number,
) => {
  const command: MatomoCommand = ['trackEvent', category, action];

  if (name) {
    command.push(name);
  }

  if (typeof value === 'number') {
    command.push(value);
  }

  pushMatomo(command);
};

export {};
